module.exports = __webpack_public_path__ + "static/media/screenshot(31).475b6a36.jpg";